import styled from 'styled-components';
import {palette} from '@/styles';

const MAX_NAME_LENGTH = 9;

export const SpotName = ({name}: {name: string}) => {
  if (!name?.length) {
    return null;
  }

  return (
    <Root>
      {name.slice(0, MAX_NAME_LENGTH)}
      {name?.length > 9 && '...'}
    </Root>
  );
};

const Root = styled.div`
  white-space: nowrap;
  color: ${palette.black};
  text-align: center;
  text-shadow: -1px 0 ${palette.white}, 0 1px ${palette.white},
    1px 0 ${palette.white}, 0 -1px ${palette.white};
  font-size: 12px;
  font-weight: 600;
`;
